var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}\r\n\t.st1{fill:#195DA9;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    fill: "black",
    id: "svg_2",
    points: "117.3,478.8 117.3,32.4 340.7,37.2 433.2,129.8 428.6,482 122.7,482  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m340.4,16l0,0l-228.5,0c-6.8,0 -12.4,5.8 -12.4,12.8l0,395.9l24.8,0l0,-383l216.1,0l0,89l85.8,0l0,342.1l-302,0l0,-48l-24.7,0l0,60.9c0,7 5.6,12.8 12.4,12.8l326.7,0c6.8,0 12.4,-5.8 12.4,-12.8l0,-355l-110.6,-114.7z",
    fill: "black",
    id: "XMLID_4_"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    fill: "black",
    height: 18.9,
    id: "XMLID_3_",
    width: 235.9,
    x: 157.3,
    y: 175.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 18.9,
    id: "XMLID_2_",
    width: 198.5,
    x: 157.3,
    y: 212.3
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m396.2,271.5l-325.5,0l0,172.2l274.3,0l51.2,-172.2zm-201.6,130.8l-15.4,0c-1.7,-1.4 -2.7,-3.5 -3.2,-6.4c-0.5,-2.8 -0.6,-5.8 -0.6,-8.6l0,-7.2c0,-4.6 -1.3,-8.2 -4,-11.1c-2.7,-2.8 -6.3,-4.1 -10.8,-4.1l-17.7,0l0,37.3l-15,0l0,-90l31,0c10,0 17.7,2.3 23.3,6.8c5.5,4.5 8.2,11.1 8.2,19.4c0,4.6 -1.2,8.6 -3.6,12.1c-2.4,3.3 -5.9,6 -10.5,8.1c5,1.7 8.7,4.2 10.9,7.8c2.2,3.6 3.3,8.1 3.3,13.5l0,7.5c0,2.7 0.4,5.3 1,7.7c0.6,2.6 1.8,4.4 3.2,5.8l-0.1,1.4l0,0zm77.3,-78l-27.8,0l0,77.9l-15,0l0,-77.9l-27.4,0l0,-12.1l70.2,0l0,12.1l0,0zm73,0l-42.6,0l0,27.5l36.1,0l0,12.1l-36.3,0l0,38.5l-15,0l0,-90l57.7,0l0,11.9l0.1,0z",
    fill: "black",
    id: "XMLID_593_"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#195da9",
    height: 133,
    id: "svg_3",
    width: 239,
    x: 108.4,
    y: 283.2
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: 106,
    fontWeight: "bold",
    id: "svg_4",
    strokeWidth: 0,
    textAnchor: "middle",
    transform: "matrix(0.907382 0 0 0.940615 16.3177 36.6365)",
    x: 219.99,
    xmlSpace: "preserve",
    y: 381
  }, "DOCX"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.55368f1c21b98e20431cfe84dc0f92fb.svg";
export { ForwardRef as ReactComponent };